module.exports = __webpack_public_path__ + "static/img/active5.918792a9.png";